import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';

import Header from '../../components/Header/Header';
import InputField from '../../components/InputField/InputField';
import Loading from '../../components/Loading/Loading';
import SubmitButton from '../../components/SubmitButton/SubmitButton';

import Api from '../../libs/Api';
import translate from '../../libs/i18n';
import emailRegex from '../../utils/emailRegex';
import { registerMeUser } from '../../store/actions/meUser';

import EmailIcon from '../../assets/svgs/EmailIcon';
import Logo from '../../assets/svgs/Logo';
import PadlockIcon from '../../assets/svgs/PadlockIcon';
import loginIllustration from '../../assets/images/healthscan-login-illustration.svg';

import { LoginStyle } from './LoginStyle';

const Login = () => {
  const language = useSelector((state) => state.settings.language);
  const dispatch = useDispatch();

  const history = useHistory();

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);
  const [mainError, setMainError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const verifyEmail = (value) => {
    if (emailRegex.test(String(value).toLowerCase())) {
      return true;
    }

    setEmailError(translate('invalidEmail', language)); 

    return false;
  };

  const verifyPassword = (value) => {
    if (value && value.length >= 1) {
      return true;
    }
    
    setPasswordError(translate('passwordRequired', language));

    return false;
  };

  const handleLogin = async (event) => {
    event.preventDefault();

    setLoading(true);
    setEmailError('');
    setPasswordError('');

    const isValidEmail = verifyEmail(email);
    const isPassword = verifyPassword(password);

    if (isValidEmail && isPassword) {
      const precheck = await Api.precheck(email, password);

      if (precheck.data.status === "email_not_confirmed") {
          setMainError('confirmEmail');
          setLoading(false);
          return;
      }

      const authenticationResponse = await Api.auth(email, password);

      if (authenticationResponse && authenticationResponse.status === 200) {
        const meUser = await Api.getMeUser();

        await Api.generateOrthancToken();
        dispatch(registerMeUser(meUser));
        history.push('/');
      } else {
        setMainError('invalidEmailOrPassword');
      }
    }

    setLoading(false);
  };

  return (
    <LoginStyle>
      <Header />
      <div className="login-content">
        <section className="image-section">
          <div className="logo-wrapper">
            <Logo theme="white" />
          </div>
          <img
            className="login-illustration"
            src={loginIllustration}
            alt="Login illustration"
          />
        </section>
        <section className="form-section">
          <div className="form-content">
            <div className="form-head">
              <h1 className="form-head-title">
                {translate('makeYourLogin', language)}
              </h1>
              <p className="form-head-description">
                {translate('typeFieldsToContinue', language)}
              </p>
            </div>
            <form onSubmit={handleLogin}>
              <InputField
                type="text"
                placeholder={translate('typeYourEmail', language)}
                inputName="email"
                value={email}
                icon={<EmailIcon />}
                error={emailError}
                onChange={setEmail}
              />
              <InputField
                type="password"
                placeholder={translate('typeYourPassword', language)}
                inputName="email"
                value={password}
                error={passwordError}
                icon={<PadlockIcon />}
                onChange={setPassword}
                noMarginBottom
              />
              <p className="forgot-password">
                <Link to="/recuperar-senha">
                  {translate('forgotMyPassword', language)}
                </Link>
              </p>
              <SubmitButton
                value={translate('enter', language)}
                error={mainError ? translate(mainError, language) : null}
                onClick={handleLogin}
              />
            </form>
            <p className="go-to-register">
              {`${translate('iIsYourFirstAccess', language)}, `}
              <Link to="/cadastrar">{translate('clickHere', language)}</Link>.
            </p>
            <p className="test-software"> <b>{translate('attention', language)}:</b> {translate('thisSoftware', language)} <a>contato@meditec.ai</a></p>
            <p className="test-software"><b>{translate('yourOpinion', language)}</b></p>
          </div>
        </section>
      </div>
      {loading ? <Loading /> : null}
    </LoginStyle>
  );
};

export default Login;
